const navLinks = [
  { id: 'home',    label: 'Home',    path: '/' },
  { id: 'about',   label: 'About',   path: '/about' },
  { id: 'events',  label: 'Events',  path: '/events' },
  { id: 'members', label: 'Members', path: '/members' },
  { id: 'joinus',  label: 'Join Us', path: '/join', cta: true },
];

export default navLinks;
